<!-- 关于我们 -->
<template>
  <div class="warp">
    <div class="banner">
      <img src="../assets/images/about_banner.gif" />
    </div>
    <div class="section">
      <div class="titleHead">
        <span>我们是谁?</span>
        <p>Company profile</p>
      </div>
      <div class="myIShu">
        <div class="test">
          <p>
            江苏绿茶网络科技有限公司成立于2012年，注册资本1000万，位于南京市江苏软件园。是一家致力于：APP开发、网站建设、微信开发、移动传媒、品牌策划、UI设计六大业务于一体的综合型科技服务企业。</p>
          <p>
            深耕互联网服务十余年，公司打造出一支行业领域内专注于产品开发、技术运维、行销策划的精英队伍。团结务实的工作态度，富有激情的设计理念和创作精神，一贯的以客户需求为导向，广泛赢得了业界的赞誉和客户的信任。同时，公司建立了完善的售后服务体系，把“品质零缺点，服务零等待，沟通零距离”做为我们客户服务中心的最高宗旨。</p>
          <p>
            本着“以人为本，奉献社会”为经营理念，公司凭借着健康的文化，优质的产品，精良的团队，我们一路走来硕果累累。做一个永续经营、基业长青的企业——这是绿茶科技一直以来的追求，这个追求将激励我们在网络科技的道路上与时俱进，不断超越自我。朋友们！绿茶科技未来的成长期待你的参与，我们凝心聚力，携手并进，再创辉煌！</p>
        </div>
        <div class="item">
          <p>Mission and Vision</p>
          <span>企业使命和愿景</span>
          <i></i>
          <h5>让大数据成为第一生产力 成为领先的互联网开放平台运营商</h5>
        </div>
        <div class="item">
          <p>Sense of Worth</p>
          <span>核心价值观</span>
          <i></i>
          <h5>用户第一 追求卓越 简单比复杂好 成就客户 创造奇迹 艰苦奋斗</h5>
        </div>
        <div class="item">
          <p>Service Idea</p>
          <span>服务理念</span>
          <i></i>
          <h5>品质零缺点 服务零等待 沟通零距离</h5>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="titleHead">
        <span>我们的轨迹</span>
        <p>Company history</p>
      </div>
      <div class="lineBox">
        <div class="line"></div>
        <div class="item left">
          <span>2020</span>
          <p>我们一直在努力 从未停止</p>
          <i></i>
        </div>
        <div class="item right">
          <span>2019-2020</span>
          <p>深圳分公司成立 聚优客商圈打造商圈共享经济</p>
          <i></i>
        </div>
        <div class="item left">
          <span>2018</span>
          <p>致力于8大产品推广</p>
          <i></i>
        </div>
        <div class="item right">
          <span>2017</span>
          <p>8大核心产品 重磅推出</p>
          <i></i>
        </div>
        <div class="item left">
          <span>2016</span>
          <p>6大强劲业务齐头并进</p>
          <i></i>
        </div>
        <div class="item right">
          <span>2015</span>
          <p>绿赚APP上线 引领交互广告新风潮</p>
          <i></i>
        </div>
        <div class="item left">
          <span>2014</span>
          <p>
            更名为江苏绿茶网络科技有限公司
            致力于开发绿茶微网 WiFi营销系统
          </p>
          <i></i>
        </div>
        <div class="item right">
          <span>2013</span>
          <p>开发无盘系统，与腾讯、网易、起凡等游戏公司精诚合作</p>
          <i></i>
        </div>
        <div class="item left">
          <span>2012</span>
          <p>更名为徐州绿茶网络科技有限公司</p>
          <i></i>
        </div>
        <div class="item right">
          <span>2005-2011</span>
          <p>致力于网吧网咖的研究及推广</p>
          <i></i>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="titleHead">
        <span>我们的文化</span>
        <p>Company Culture</p>
      </div>
      <div class="culture">
        <ul>
          <li>
            <img src="../assets/images/page01.jpg" />
          </li>
          <li>
            <img src="../assets/images/page02.jpg" />
          </li>
          <li>
            <img src="../assets/images/page03.jpg" />
          </li>
          <li>
            <img src="../assets/images/page04.jpg" />
          </li>
        </ul>
        <div class="cultureBtn">
          <p>和我们一起工作</p>
          <span>共同的激情，不同的观点</span>
          <button>加入我们</button>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="sectionBg">
        <div class="titleHead">
          <span>我们的荣誉</span>
          <p>Company HONEOR</p>
        </div>
        <div class="swiperOption">
          <swiper :options="swiperOption" class="swiper-container">
            <!-- slides -->
            <swiper-slide class="swiper-item" v-for="(item,index) of swiperList" :key="index">
              <div class="box">
                <img class="swiper-img" :src="item.imgUrl" alt="去哪儿门票" />
              </div>
            </swiper-slide>
            <!-- Optional controls ,显示小点-->
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { honorList } from "@/api/other.js";

export default {
  name: "",

  data() {
    return {
      swiperOption: {
        loop: true,
        speed: 1000, //匀速时间
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        slidesPerView: 3,
        slidesPerGroup: 3,
        pagination: {
          el: ".swiper-pagination",
        },
        centeredSlides: true,
      },
      swiperList: [
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
        { imgUrl: require("../assets/images/page05.jpg") },
      ],
    };
  },
  mounted() {},
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.swiperList = [];
      honorList({ type: 0 })
        .then((res) => {
          res.map((item) => {
            this.swiperList.push({
              imgUrl: `https://api.jsgtkj.com${item.imgUrl}`,
            });
          });
        })
        .catch((err) => {
          // this.$Message.error(err);
        });
    },
  },
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;

  .banner {
    img {
      width: 100%;
    }
  }

  .section {
    .sectionBg {
      background-color: #ecedf0;
      border-radius: 0.1rem;
      padding: 0.3rem 0.2rem;
      margin-bottom: 1rem;
    }

    .swiperOption {
      .swiper-item {
        .box {
          padding: 0 0.2rem;
          padding-bottom: 1.3rem;
        }
      }
    }

    padding: 0.2rem 0.4rem;
    background-color: #fff;

    .titleHead {
      text-align: center;
      padding: 0.4rem 0;

      span {
        font-size: 0.66rem;
      }

      p {
        font-size: 0.38rem;
        text-transform: uppercase;
        color: #000;
        opacity: 0.2;
        padding: 0.1rem 0;
      }
    }

    .myIShu {
      .test {
        font-size: 0.38rem;

        p {
          color: #888;
          line-height: 0.74rem;
          padding-bottom: 0.3rem;
          text-indent: 2em;
        }
      }

      .item {
        background-color: rgb(238, 240, 236);
        border-radius: 0.3rem 0.3rem 0 0;
        padding: 0.5rem 0.3rem;
        margin-bottom: 0.5rem;
        text-align: center;

        p {
          font-size: 0.24rem;
          padding: 0.2rem 0 0;
          color: #666;
        }

        span {
          font-size: 0.42rem;
        }

        i {
          width: 0.8rem;
          height: 0.05rem;
          background-color: #333;
          display: block;
          margin: 0.3rem auto;
        }

        h5 {
          font-size: 0.3rem;
          font-weight: 400;
          color: #888;
        }
      }
    }

    .lineBox {
      position: relative;
      margin-top: 0.6rem;

      .line {
        background-color: #262e43;
        width: 2px;
        height: 92%;
        position: absolute;
        left: 50%;
        top: 0.2rem;
        margin-left: -1px;
      }

      .item {
        position: relative;
        padding-bottom: 0.6rem;

        span {
          font-size: 0.4rem;
          font-family: Arial, Helvetica, sans-serif;
        }

        p {
          font-size: 0.34rem;
          padding-top: 0.1rem;
        }

        i {
          width: 0.18rem;
          height: 0.18rem;
          border-radius: 0.2rem;
          background-color: #262e43;
          display: block;
          position: absolute;
          left: 50%;
          top: 0.11rem;
          margin-left: -0.08rem;
        }
      }

      .left {
        padding-right: 5.5rem;
        text-align: right;
      }

      .right {
        padding-left: 5.6rem;
      }
    }

    .culture {
      ul {
        overflow: hidden;

        li {
          float: left;
          padding-bottom: 0.4rem;

          &:nth-child(2n) {
            float: right;
          }

          img {
            width: 4.8rem;
          }
        }
      }
    }

    .cultureBtn {
      text-align: center;
      padding: 0.4rem 0 0.6rem;

      p {
        font-size: 0.44rem;
        padding-bottom: 0.1rem;
      }

      span {
        font-size: 0.36rem;
        color: #666;
        display: block;
        padding-bottom: 0.5rem;
      }

      button {
        display: block;
        width: 4rem;
        height: 1rem;
        background-color: rgb(38, 46, 67);
        color: #fff;
        font-size: 0.34rem;
        border-radius: 1rem;
        margin: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about.vue